import { PropsWithChildren } from "react";

import { cn } from "~/lib/utils";

interface Props {
  className?: string;
}

export default function PageContent({
  children,
  className,
}: PropsWithChildren<Props>) {
  return (
    <div className="mt-6 rounded-lg border-none">
      <div className="md:p-6">
        <div
          className={cn(
            "flex min-h-[calc(100vh-56px-64px-20px-24px-56px-48px)]",
            className
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
